export default "__VITE_ASSET__f98c28a6__"